<script>
  import Icon from "@shared/svelte/Components/Icon.svelte";

</script>

<style>
  .provi-logo {
    width: 76px;
    height: 38px;
  }

  @media (max-width: 700px) {
    .provi-logo {
      width: 48px;
      height: 24px;
    }
  }

</style>

<button on:click class="provi-logo">
  <Icon
    type="ProviLogo"
    extraStyles="height: 100%; width: 80px;"
    extraClassNames="fizz-icon-logo fizz-text-brand"
  />
</button>
